import styled from '@emotion/styled';

export const Container = styled.div`
  width: 100%;
  position: relative;

  .application-btn {
    width: 100%;
    display: flex;
    justify-content: flex-end;

  }
`;

export const ApplicationsContentFiltersCount = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  background-color: ${({ theme }) => theme.palette?.brand.primary.base};
  font-size: 12px;
  line-height: 0px;
  border: 1px solid ${({ theme }) => theme.palette?.brand.primary.base};
  font-weight: 600;
  width: 26px;
  height: 26px;
  border-radius: 100px;
  margin-left: 10px;
  cursor: pointer;
  z-index: 99;
`;

export const ButtonApplicationContainer = styled.div`
  border-radius: 10px;
  display: flex;
  justify-content: space-between;
`;

export const FilterArea = styled.div`
  display: flex;
  width: 100%;
  margin-right: 11px;
  @media screen and (max-width: ${({ theme }) =>
    theme.breakpoints?.values?.laptop + 'px'}) {
      flex-direction: column;

  }
`;

export const TableArea = styled.div`
  width: 100%;
  margin-top: 26px;
`;
